import React, { useState, useEffect } from 'react';
import { X, BellOff } from 'lucide-react';

const PhantomBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('phantom_banner_dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismissForever = () => {
    localStorage.setItem('phantom_banner_dismissed', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="phantom-banner">
      <div className="phantom-banner-content">
        <span className="phantom-banner-text">
          <strong>⚠️ Phantom Wallet Users:</strong> Enable Blinks in Experimental Features (Settings → Experimental Features → Enable "Solana Blinks")
        </span>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button 
            className="phantom-banner-close"
            onClick={handleDismissForever}
            aria-label="Don't show again"
            title="Don't show again"
          >
            <BellOff size={16} />
          </button>
          <button 
            className="phantom-banner-close"
            onClick={() => setIsVisible(false)}
            aria-label="Close banner"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhantomBanner;





